import EventoListView from './views/EventoListView.vue'
import EventoCreateView from './views/EventoCreateView.vue'
import EventoView from './views/EventoView.vue'

export default [
  {
    path: '/eventos',
    name: 'eventos',
    component: EventoListView
  },
  {
    path: '/evento-nuevo',
    name: 'nuevoEvento',
    component: EventoCreateView
  },
  {
    path: '/evento-detalle/:id',
    name: 'detalleEvento',
    component: EventoView
  },
  {
    path: '/evento-editar/:pk',
    name: 'editarEvento',
    component: EventoCreateView
  }
]
